import { Textbox } from 'fabric';
import { ASPECT_RATIOS } from './canvas-helpers';
import { loadFont, applyTextEffect } from './fonts';

/**
 * Apply a template definition to a Fabric.js canvas.
 * Shared between TemplatePanel (inline panel) and CanvasEditor (initialTemplate prop).
 *
 * @param {fabric.Canvas} canvas - The Fabric.js canvas instance
 * @param {Object} template - Template definition from MEME_TEMPLATES or saved templates
 * @param {Object} callbacks - { onAspectChange, onBackgroundChange, onModified }
 */
export async function applyTemplate(canvas, template, { onAspectChange, onBackgroundChange, onModified } = {}) {
  if (!canvas) return;

  if (template.canvasJSON) {
    await canvas.loadFromJSON(template.canvasJSON);
    canvas.renderAll();
  } else {
    canvas.clear();
    const ar = ASPECT_RATIOS.find(a => a.key === template.aspect) || ASPECT_RATIOS[0];
    onAspectChange?.(ar);
    onBackgroundChange?.(template.background);

    for (const layer of template.layers) {
      if (layer.type === 'text') {
        if (layer.fontFamily) await loadFont(layer.fontFamily);

        const textObj = new Textbox(layer.text, {
          left: layer.x * ar.width,
          top: layer.y * ar.height,
          originX: 'center',
          originY: 'center',
          fontSize: layer.fontSize || 48,
          fontFamily: layer.fontFamily || 'Inter',
          fill: layer.fill || '#FFFFFF',
          fontWeight: layer.fontWeight || '400',
          textAlign: layer.textAlign || 'center',
          charSpacing: layer.charSpacing || 0,
          width: (layer.width || 0.8) * ar.width,
          editable: true,
        });

        textObj.set({
          cornerSize: 12,
          touchCornerSize: 40,
          cornerPadding: 10,
          cornerColor: '#FFFFFF',
          cornerStrokeColor: '#000000',
          borderColor: '#FFFFFF',
          transparentCorners: false,
        });
        textObj.__id = `template-${Date.now()}-${Math.random().toString(36).slice(2, 6)}`;
        textObj.__layerName = 'Text';

        if (layer.effect && layer.effect !== 'none') {
          textObj.__textEffect = layer.effect;
          applyTextEffect(textObj, layer.effect);
        }

        canvas.add(textObj);
      }
    }

    canvas.renderAll();
  }

  onModified?.();
}
